import { FormattedMessage } from 'react-intl'
import { faChartPieSimple } from '@fortawesome/pro-solid-svg-icons'

import { Card, CardBody, CardHeader } from 'Components/_theme'

import { DeviceCountCardChart } from '../DeviceCountCardChart/DeviceCountCardChart'
import { organisationDashboardMockDeviceCountData } from '../OrganisationDashboardDefault/OrganisationDashboardDefault.mocks'

export const DashboardDeviceCountCard = () => {
  const data = organisationDashboardMockDeviceCountData.map(
    ({ count }) => count,
  )
  const labels = organisationDashboardMockDeviceCountData.map(
    ({ name }) => name,
  )

  return (
    <Card className="DashboardDeviceCountCard">
      <CardHeader
        icon={faChartPieSimple}
        subtitle="Lorem ipsum dolor sit amet, consectetur"
      >
        <FormattedMessage id="DashboardDeviceCountCard_fleet_overview" />
      </CardHeader>

      <CardBody>
        <DeviceCountCardChart data={data} labels={labels} />
      </CardBody>
    </Card>
  )
}
